import React from "react";
import { Check, Shop } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { formatCurrencyINR } from "../../utils/function";

const SuccessPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const item = location.state.item

  return (
    <div>
   <div className="bg-[#FDFCFB] dark:bg-slate-950 flex flex-col items-center justify-center p-6 transition-colors duration-300">
  {/* Main Container: Limits width on desktop, full width on mobile */}
  <div className="w-full max-w-xl bg-white dark:bg-slate-900 md:shadow-[0_20px_50px_rgba(0,0,0,0.05)] md:border md:border-slate-100 md:dark:border-slate-800 rounded-[3rem] p-8 md:p-12 animate-in fade-in zoom-in duration-500">
    
    {/* Animated Icon Section */}
    <div className="flex flex-col items-center">
      <div className="relative mb-8">
        <div className="w-32 h-32 bg-orange-50 dark:bg-orange-900/10 rounded-[3rem] flex items-center justify-center animate-pulse transition-colors">
          <div className="w-24 h-24 bg-orange-100 dark:bg-orange-900/20 rounded-[2.5rem] flex items-center justify-center">
            <div className="w-16 h-16 bg-[#E67E22] dark:bg-orange-600 rounded-[1.5rem] flex items-center justify-center shadow-xl shadow-orange-200 dark:shadow-none">
              <Check size={32} className="text-white" strokeWidth={4} />
            </div>
          </div>
        </div>

        {/* Floating Decorative Dots */}
        <div className="absolute -top-2 -right-2 w-6 h-6 bg-blue-500 rounded-full border-4 border-white dark:border-slate-900 shadow-sm" />
        <div className="absolute -bottom-1 -left-2 w-4 h-4 bg-orange-300 rounded-full border-2 border-white dark:border-slate-900 shadow-sm" />
      </div>

      {/* Text Content */}
      <h2 className="text-3xl font-black text-slate-800 dark:text-white mb-3 uppercase tracking-tight">
        {t("orderPlaced")}!
      </h2>
      <p className="text-slate-400 dark:text-slate-500 font-bold text-base leading-relaxed max-w-sm mb-10">
        {t("yourOrder")}
        <span className="text-slate-800 dark:text-slate-200">
          {" "}
          #{item?.order_number}
        </span>{" "}
        {t("hasReceived")}.
      </p>

      {/* Store Info Card (Redesigned for better horizontal balance on desktop) */}
      <div className="w-full bg-[#FDFCFB] dark:bg-slate-800/50 rounded-[2.5rem] p-6 border border-orange-100 dark:border-slate-700/50 flex items-center gap-5 mb-10 transition-all hover:border-orange-200">
        <div className="w-14 h-14 bg-white dark:bg-slate-800 rounded-2xl flex items-center justify-center shadow-md shrink-0">
          <Shop size={24} className="text-[#E67E22]" />
        </div>
        <div className="text-left">
          <p className="text-[10px] font-black text-orange-500 uppercase tracking-[0.2em] leading-none mb-2">
            {item?.order_type_label}
          </p>
          <p className="font-black text-slate-800 dark:text-slate-100 text-base truncate">
            {item?.store_name}
          </p>
          <p className="font-bold text-slate-600 dark:text-slate-400 text-sm">
            {t("amount")}: <span className="text-slate-900 dark:text-white font-black">{formatCurrencyINR(item?.total_amount)}</span>
          </p>
        </div>
      </div>

      {/* Action Buttons: Responsive Widths */}
      <div className="w-full flex flex-col md:flex-row gap-4">
        <button
          type="button"
          onClick={() => navigate(`/order-details/${item.uuid}`)}
          className="flex-1 bg-slate-900 dark:bg-[#E67E22] text-white py-5 rounded-2xl font-black uppercase tracking-widest text-xs shadow-xl shadow-slate-200 dark:shadow-none hover:opacity-90 active:scale-95 transition-all"
        >
          {t("trackMyOrder")}
        </button>
        <button
          onClick={() => navigate("/customer-store")}
          className="flex-1 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-300 py-5 rounded-2xl font-bold uppercase tracking-widest text-[10px] border border-slate-100 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 transition-all active:scale-95"
        >
          {t("newOrder")}
        </button>
      </div>
    </div>
  </div>
</div>
    </div>
  );
};

export default SuccessPage;
